<template>
  <div class="px-3 my-12">
    <div class="w-full max-w-screen-lg mx-auto">
      <div class="grid grid-cols-1 gap-8 lg:grid-cols-3 lg:gap-6">
        <div>
          <div class="flex">
            <div
              class="w-14 h-14 bg-cover bg-no-repeat bg-center"
              style="
                background-image: url('https://cdn2.rcstatic.com/com.rentalcars.185492029745.eu-west-1.web.prod.static-live/images/landing-pages/usps/mobile/usp_calendar@2x.png');
              "
            ></div>
            <div class="ml-3 flex-1">
              <h3 class="font-bold text-lg">Flexible rentals</h3>
              <p>Cancel or change most bookings for free up to 48 hours before pick-up</p>
            </div>
          </div>
        </div>
        <div>
          <div class="flex">
            <div
              class="w-14 h-14 bg-cover bg-no-repeat bg-center"
              style="
                background-image: url('https://cdn2.rcstatic.com/com.rentalcars.185492029745.eu-west-1.web.prod.static-live/images/landing-pages/usps/mobile/usp_magnifier@2x.png');
              "
            ></div>
            <div class="ml-3 flex-1">
              <h3 class="font-bold text-lg">No hidden fees</h3>
              <p>Know exactly what you’re paying</p>
            </div>
          </div>
        </div>
        <div>
          <div class="flex">
            <div
              class="w-14 h-14 bg-cover bg-no-repeat bg-center"
              style="
                background-image: url('https://cdn2.rcstatic.com/com.rentalcars.185492029745.eu-west-1.web.prod.static-live/images/landing-pages/usps/mobile/usp_wallet@2x.png');
              "
            ></div>
            <div class="ml-3 flex-1">
              <h3 class="font-bold text-lg">Price Match Guarantee</h3>
              <p>Found the same deal for less? We’ll match the price.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-features-section',
}
</script>
